/**
 * @author Brendan Magee, Umer Hassan
 * @desc Service for platforms that are open to pitching
 */

function platformService($http, $q) {
  const service = {
    // cache will be saved per website, all platforms will be saved under 'all'
    cache: {}
  };
  const allPlatforms = 'all';
  const endpoint = 'api/platforms';

  service.getAll = (params = null) => {
    if ((!params || !params.website) && service.cache[allPlatforms]) {
      return $q.when(service.cache[allPlatforms]);
    } else if ((params && params.website) && service.cache[params.website]) {
      return service.cache[params.website];
    }

    return $http.get(endpoint, { params })
      .then(({ data } = {}) => {
        // Cache platforms for only websites, not paths
        if ((!params || !params.website) && Array.isArray(data)) {
          // Populate the cache for all platforms
          service.cache[allPlatforms] = data;

          // Populate the cache for each website key
          data.forEach((platform) => {
            if (!service.cache[platform.website]) {
              service.cache[platform.website] = [];
            }

            service.cache[platform.website].push(platform);
          });
        } else if (params && params.website && !service.cache[params.website]) {
          service.cache[params.website] = data;
        }
        return data;
      });
  };

  const getPlatformWebsite = (website) => {
    let platformWebsite = website || allPlatforms;

    // If website was provided and platforms are not cached for that, use all platforms
    platformWebsite = !service.cache[platformWebsite] && service.cache[allPlatforms] ?
      allPlatforms : platformWebsite;
    return platformWebsite;
  };

  service.isPlatform = (path, website) => {
    const platformWebsite = getPlatformWebsite(website);
    return service.cache[platformWebsite].findIndex(platform => path === platform.path) >= 0;
  };

  service.getPlatformName = (path, website) => {
    let platformName = null;
    const platformWebsite = getPlatformWebsite(website);

    if (service.cache[platformWebsite]) {
      const platformFound = service.cache[platformWebsite].find(platform => path === platform.path);
      platformName = platformFound ? platformFound.title : '';
    }
    return platformName;
  };

  service.getPlatformsByPathAndWebsiteId = (path, website) => {
    let platforms = null;
    const platformWebsite = getPlatformWebsite(website);

    if (service.cache[platformWebsite]) {
      if (Array.isArray(path)) {
        platforms = [];
        path.forEach((platformPath) => {
          const matchingPlatform =
            service.cache[platformWebsite].find(platform =>
              platform.path === platformPath
              && platform.website === website
            );
          if (matchingPlatform) {
            platforms.push(matchingPlatform);
          }
        });
      } else {
        platforms = service.cache[platformWebsite].filter(platform =>
          platform.path === path
          && platform.website === website
        );
      }
    }
    return platforms;
  };

  service.getPlatformsByWebsiteId = (id) => {
    const platformWebsite = getPlatformWebsite(id);

    const platforms = service.cache[platformWebsite] ? service.cache[platformWebsite].filter(
      platform => platform.website === id) : [];

    return platforms;
  };

  return service;
}

const factoryArray = [
  '$http',
  '$q',
  platformService
];

module.exports = (ngModule) => {
  ngModule.factory('platformService', factoryArray);
};
